import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

const Content = () => {
  const { isAuthenticated, user } = useAuth0();
  const roles = user != null && user["http://exoticcartrader.com/role"];
  return (
      <div>
        {roles && roles.includes("Photographer") ? (
            <div style={{display: 'flex'}}>
              <video controls width="40%" height="auto" style={{margin: 'auto'}}>
                <source
                    src={'https://ect-public-assets.s3.us-east-1.amazonaws.com/creators/ECT+Instructions+Sheet+Overview.MP4'}/>
              </video>

              <video controls width="40%" height="auto" style={{margin: 'auto'}}>
                <source
                    src={'https://ect-public-assets.s3.us-east-1.amazonaws.com/creators/Photo+Instructions+Page.MP4'}/>
              </video>
            </div>
        ) : null}
        <div className="next-steps">
          {isAuthenticated ? null : (
              <h2 className="my-5 text-center">Press "Log in" in the top right to either log in or sign up with Exotic
                Car Trader</h2>)}

        </div>
      </div>
  );
}

export default Content;
